import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice
const name = "paymentReport";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const paymentReportAction = { ...slice.actions, ...extraActions };
export const paymentReportReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    loading: false,
    InmateLastName: [],
    InmateFirstName: [],
    PublicUserLastName: [],
    PublicUserFirstName: [],
    DuplicatePaymentTransaction: {},
    DeleteDuplicatePayment: [],
  };
}

function createReducers() {
  return {
    setmanagementUserData,
    resetForm: (state) => {
      state.Username = "";
      state.FullName = "";
      state.UserRoleID = 0;
      state.City = "";
      state.ZIP = "";
      state.ActiveStatus = 0;
    },
    clearManagementUserInfo,
    clearPaymentReportFullList,
  };

  function setmanagementUserData(state, action) {
    state.managementUserData = action.payload && action.payload;
  }
  function clearManagementUserInfo(state) {
    state.managementUserInfo = [];
  }
  function clearPaymentReportFullList(state) {
    state.PaymentReportFullList = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/PaymentReport`;
  return {
    LoadInmateLastNames: LoadInmateLastNames(),
    LoadInmateFirstNames: LoadInmateFirstNames(),
    LoadPublicUserLastNames: LoadPublicUserLastNames(),
    LoadPublicUserFirstNames: LoadPublicUserFirstNames(),
    LoadDuplicatePaymentTransaction: LoadDuplicatePaymentTransaction(),
    DeleteDuplicatePayment: DeleteDuplicatePayment(),
  };

  function LoadInmateLastNames() {
    return createAsyncThunk(
      `${name}/LoadInmateLastNames`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadInmateLastNames`, params)
    );
  }

  function LoadInmateFirstNames() {
    return createAsyncThunk(
      `${name}/LoadInmateFirstNames`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadInmateFirstNames`, params)
    );
  }

  function LoadPublicUserLastNames() {
    return createAsyncThunk(
      `${name}/LoadLastNames`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadLastNames`, params)
    );
  }

  function LoadPublicUserFirstNames() {
    return createAsyncThunk(
      `${name}/LoadFirstNames`,
      async (params) =>
        await fetchWrapper.post(`${baseUrl}/LoadFirstNames`, params)
    );
  }

  function LoadDuplicatePaymentTransaction() {
    return createAsyncThunk(
      `${name}/LoadDuplicatePaymentTransaction`,
      async (params) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadDuplicatePaymentTransaction`,
          params
        )
    );
  }

  /// Grid delete..
  function DeleteDuplicatePayment() {
    return createAsyncThunk(
      `${name}/DeleteDuplicatePaymentTransaction`,
      async (DuplicatePaymentTransactionID) => {
        return await fetchWrapper.post(
          `${baseUrl}/DeleteDuplicatePaymentTransaction?duplicatePaymentTransactionID=${DuplicatePaymentTransactionID}`
        );
      }
    );
  }
}

function createExtraReducers(builder) {
  builder
    //LoadInmateLastNames
    .addCase(extraActions.LoadInmateLastNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadInmateLastNames.fulfilled, (state, action) => {
      state.loading = false;
      state.InmateLastName = action.payload;
      state.error = null;
    })
    .addCase(extraActions.LoadInmateLastNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //LoadInmateFirstNames
    .addCase(extraActions.LoadInmateFirstNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.LoadInmateFirstNames.fulfilled, (state, action) => {
      state.loading = false;
      state.InmateFirstName = action.payload;
      state.error = null;
    })
    .addCase(extraActions.LoadInmateFirstNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //LoadPublicUserLastNames
    .addCase(extraActions.LoadPublicUserLastNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicUserLastNames.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PublicUserLastName = action.payload;
        state.error = null;
      }
    )
    .addCase(extraActions.LoadPublicUserLastNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //LoadPublicUserFirstNames
    .addCase(extraActions.LoadPublicUserFirstNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicUserFirstNames.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PublicUserFirstName = action.payload;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPublicUserFirstNames.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    //LoadDuplicatePaymentTransaction
    .addCase(extraActions.LoadDuplicatePaymentTransaction.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    // .addCase(extraActions.LoadDuplicatePaymentTransaction.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.DuplicatePaymentTransaction = action.payload;
    //     state.error = null;
    // })
    .addCase(
      extraActions.LoadDuplicatePaymentTransaction.fulfilled,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.exportExcel) {
          state.PaymentReportFullList = action.payload;
          //state.DuplicatePaymentTransaction = action.payload;
        } else {
          state.PaymentReportList = action.payload;
          //state.DuplicatePaymentTransaction = action.payload;
        }
        state.loading = false;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadDuplicatePaymentTransaction.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      }
    )

    /// grid delete
    .addCase(extraActions.DeleteDuplicatePayment.pending, (state) => {
      state.loading = true;
      state.error = null;
    })

    .addCase(extraActions.DeleteDuplicatePayment.fulfilled, (state, action) => {
      state.loading = false;
      state.deletedata = action.payload;
    })
    .addCase(extraActions.DeleteDuplicatePayment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
